import { UrlConstants } from "../url.constants";
export class ApiDemolitionManagementConstants {
    static URL = UrlConstants.API_V2 + "DemolitionManagement";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalDemolitionManagementApplication";
    static FUNCTION_CREATE_RESUBMITTED_APPLICATION = "CreateResubmittedPortalDemolitionManagementApplication";
    static FUNCTION_GET_MY_AFLA_PORTAL_DEMOLITION_APPLICATIONS = "GetMyAflaPortalDemolitionManagementApplications";
    static FUNCTION_GET_ALL_AFLA_PORTAL_DEMOLITION_APPLICATIONS = "GetAllAFLAPortalDemolitionManagementApplications";
}
